import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vModelRadio as _vModelRadio, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0be93312")

_pushScopeId("data-v-0be93312")
const _hoisted_1 = {
  class: "modal fade",
  id: "modal_edit_end_user",
  tabindex: "-1",
  "aria-hidden": "true",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_2 = { class: "modal-dialog modal-lg modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_new_address_header"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("div", {
  class: "btn btn-sm btn-icon",
  "data-bs-dismiss": "modal"
}, [
  /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-1" }, [
    /*#__PURE__*/_createVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_6 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_7 = { class: "scroll-y me-n7 pe-7" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-md-6" }
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = { class: "col-md-12" }
const _hoisted_12 = { class: "col-md-12" }
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "col-md-12  mt-3" }
const _hoisted_16 = { class: "d-flex flex-stack" }
const _hoisted_17 = { class: "me-5" }
const _hoisted_18 = { class: "fs-5 fw-bold" }
const _hoisted_19 = { class: "fs-7 fw-bold text-gray-400" }
const _hoisted_20 = { class: "form-check-label fw-bold text-gray-400" }
const _hoisted_21 = { class: "fv-row mb-5 account-status" }
const _hoisted_22 = { class: "d-flex flex-stack" }
const _hoisted_23 = { class: "me-5 account-status-msg-area" }
const _hoisted_24 = { class: "fs-5 fw-bold" }
const _hoisted_25 = { class: "fs-7 fw-bold text-gray-400" }
const _hoisted_26 = { class: "form-check-label fw-bold text-gray-400" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { class: "fs-5 fw-bold mt-4" }
const _hoisted_29 = { class: "col-md-12 child-items mt-5 customer-permissions" }
const _hoisted_30 = { class: "checkbox" }
const _hoisted_31 = /*#__PURE__*/_createVNode("span", { class: "default" }, null, -1)
const _hoisted_32 = { class: "list-group list-group-flush m-0 mt-2" }
const _hoisted_33 = { class: "checkbox" }
const _hoisted_34 = /*#__PURE__*/_createVNode("span", { class: "default" }, null, -1)
const _hoisted_35 = {
  class: "radio-container d-flex flex-row",
  style: {"width":"100% !important"}
}
const _hoisted_36 = { class: "fw-bold block px-2 mb-0" }
const _hoisted_37 = { class: "toggle-label  block fs-5 fw-bold ml-auto" }
const _hoisted_38 = /*#__PURE__*/_createVNode("span", { class: "toggle-wrapper" }, null, -1)
const _hoisted_39 = /*#__PURE__*/_createVNode("span", { class: "toggle-default" }, null, -1)
const _hoisted_40 = { class: "fs-5 fw-bold mt-4" }
const _hoisted_41 = { class: "col-md-12 mt-5 customer-permissions" }
const _hoisted_42 = { class: "checkbox" }
const _hoisted_43 = /*#__PURE__*/_createVNode("span", { class: "default" }, null, -1)
const _hoisted_44 = { class: "list-group list-group-flush m-0 mt-2" }
const _hoisted_45 = { class: "checkbox" }
const _hoisted_46 = /*#__PURE__*/_createVNode("span", { class: "default" }, null, -1)
const _hoisted_47 = { class: "modal-footer flex-center" }
const _hoisted_48 = {
  type: "reset",
  class: "btn btn-white me-3",
  "data-bs-dismiss": "modal"
}
const _hoisted_49 = { class: "indicator-label" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_Input = _resolveComponent("Input")!
  const _component_Select = _resolveComponent("Select")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_InnerLoader, { loading: _ctx.loading }, null, 8, ["loading"]),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_el_form, {
            model: _ctx.customer,
            ref: "addEndUserForm"
          }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_4, [
                _createVNode("h2", null, _toDisplayString(`${_ctx.$t('message.EDIT')} ${_ctx.$t('message.CUSTOMER')}`), 1),
                _hoisted_5
              ]),
              _createVNode("div", _hoisted_6, [
                _createVNode("div", _hoisted_7, [
                  _createVNode("div", _hoisted_8, [
                    _createVNode("div", _hoisted_9, [
                      _createVNode(_component_Input, {
                        type: "text",
                        name: "name",
                        label: _ctx.$t('message.NAME'),
                        required: true,
                        placeholder: `${_ctx.$t('message.ENTER')} ${_ctx.$t('message.NAME')}`,
                        requiredMsg: `${_ctx.$t('message.NAME')} ${_ctx.$t('message.IS_REQUIRED')}`,
                        "onUpdate:name": _cache[1] || (_cache[1] = ($event: any) => (_ctx.customer.name = $event)),
                        target: "name",
                        value: _ctx.customer.name
                      }, null, 8, ["label", "placeholder", "requiredMsg", "name", "value"])
                    ]),
                    _createVNode("div", _hoisted_10, [
                      _createVNode(_component_Input, {
                        type: "text",
                        name: "email",
                        label: _ctx.$t('message.EMAIL'),
                        required: true,
                        placeholder: `${_ctx.$t('message.ENTER')} ${_ctx.$t('message.EMAIL')}`,
                        requiredMsg: `${_ctx.$t('message.EMAIL')} ${_ctx.$t('message.IS_REQUIRED')}`,
                        email: _ctx.customer.email,
                        "onUpdate:email": _cache[2] || (_cache[2] = ($event: any) => (_ctx.customer.email = $event)),
                        target: "email",
                        rule: "email",
                        ruleMsg: _ctx.$t('message.ENTER_A_VALID_EMAIL_ADDRESS'),
                        value: _ctx.customer.email,
                        disabled: true
                      }, null, 8, ["label", "placeholder", "requiredMsg", "email", "ruleMsg", "value"])
                    ]),
                    _createVNode("div", _hoisted_11, [
                      _createVNode(_component_Input, {
                        type: "password",
                        name: "password",
                        label: _ctx.$t('message.PASSWORD'),
                        placeholder: `${_ctx.$t('message.ENTER')} ${_ctx.$t('message.PASSWORD')}`,
                        requiredMsg: `${_ctx.$t('message.PASSWORD')} ${_ctx.$t('message.IS_REQUIRED')}`,
                        password: _ctx.customer.password,
                        "onUpdate:password": _cache[3] || (_cache[3] = ($event: any) => (_ctx.customer.password = $event)),
                        target: "password",
                        value: _ctx.customer.password
                      }, null, 8, ["label", "placeholder", "requiredMsg", "password", "value"])
                    ]),
                    _createVNode("div", _hoisted_12, [
                      _createVNode(_component_Input, {
                        type: "password",
                        name: "password_confirmation",
                        label: `${_ctx.$t('message.CONFIRM')} ${_ctx.$t('message.PASSWORD')}`,
                        placeholder: `${_ctx.$t('message.CONFIRM')} ${_ctx.$t('message.PASSWORD')}`,
                        requiredMsg: `${_ctx.$t('message.CONFIRM')} ${_ctx.$t('message.PASSWORD')} ${_ctx.$t('message.IS_REQUIRED')}`,
                        password_confirmation: _ctx.customer.password_confirmation,
                        "onUpdate:password_confirmation": _cache[4] || (_cache[4] = ($event: any) => (_ctx.customer.password_confirmation = $event)),
                        target: "password_confirmation",
                        value: _ctx.customer.password_confirmation
                      }, null, 8, ["label", "placeholder", "requiredMsg", "password_confirmation", "value"])
                    ]),
                    _createVNode("div", _hoisted_13, [
                      _createVNode(_component_Input, {
                        type: "text",
                        name: "phone_number",
                        label: _ctx.$t('message.PHONE_NUMBER'),
                        required: true,
                        placeholder: `${_ctx.$t('message.ENTER')} ${_ctx.$t('message.PHONE_NUMBER')}`,
                        requiredMsg: `${_ctx.$t('message.PHONE_NUMBER')} ${_ctx.$t('message.IS_REQUIRED')}`,
                        phone_number: _ctx.customer.phone_number,
                        "onUpdate:phone_number": _cache[5] || (_cache[5] = ($event: any) => (_ctx.customer.phone_number = $event)),
                        target: "phone_number",
                        value: _ctx.customer.phone_number
                      }, null, 8, ["label", "placeholder", "requiredMsg", "phone_number", "value"])
                    ]),
                    _createVNode("div", _hoisted_14, [
                      _createVNode(_component_Select, {
                        name: "country_id",
                        target: "country_id",
                        label: _ctx.$t('message.COUNTRIES'),
                        required: true,
                        filterable: true,
                        placeholder: _ctx.$t('message.SELECT'),
                        country_id: _ctx.customer.country_id,
                        "onUpdate:country_id": _cache[6] || (_cache[6] = ($event: any) => (_ctx.customer.country_id = $event)),
                        selectData: _ctx.countries,
                        value: _ctx.customer.country_id,
                        callEmit: true
                      }, null, 8, ["label", "placeholder", "country_id", "selectData", "value"])
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_15, [
                  _createVNode("div", _hoisted_16, [
                    _createVNode("div", _hoisted_17, [
                      _createVNode("label", _hoisted_18, _toDisplayString(`${_ctx.$t('message.CUSTOMER')} ${_ctx.$t('message.STATUS')}`), 1),
                      _createVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('message.SET_CUSTOMER_STATUS_ACTIVE_OR_INACTIVE')), 1)
                    ]),
                    _createVNode("span", _hoisted_20, [
                      _createVNode(_component_el_switch, {
                        modelValue: _ctx.customer.status,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.customer.status = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_21, [
                  _createVNode("div", _hoisted_22, [
                    _createVNode("div", _hoisted_23, [
                      _createVNode("label", _hoisted_24, _toDisplayString(`${_ctx.$t('message.CAN_MANAGE_ADDRESSES')}`), 1),
                      _createVNode("div", _hoisted_25, _toDisplayString(`${_ctx.$t('message.ACCOUNT')}
											${_ctx.$t('message.ADD_EDIT_ADDRESS')}`), 1)
                    ]),
                    _createVNode("span", _hoisted_26, [
                      _createVNode(_component_el_switch, {
                        modelValue: _ctx.canManageAddresses,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.canManageAddresses = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]),
                (_ctx.canManageAddresses)
                  ? (_openBlock(), _createBlock("div", _hoisted_27, [
                      _createVNode("label", _hoisted_28, _toDisplayString(_ctx.$t('message.ADDRESSES')), 1),
                      _createVNode("div", _hoisted_29, [
                        _createVNode("div", null, [
                          _createVNode("label", _hoisted_30, [
                            _withDirectives(_createVNode("input", {
                              type: "checkbox",
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.allSelectAddress = $event)),
                              id: "all",
                              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.selectedAllAddresses($event, _ctx.addresses)))
                            }, null, 512), [
                              [_vModelCheckbox, _ctx.allSelectAddress]
                            ]),
                            _hoisted_31
                          ]),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('message.ALL')), 1)
                        ]),
                        _createVNode("ul", _hoisted_32, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.addresses, (address, index2) => {
                            return (_openBlock(), _createBlock("li", {
                              class: "list-group-item d-flex flex-column align-items-start",
                              key: index2
                            }, [
                              _createVNode("div", null, [
                                _createVNode("label", _hoisted_33, [
                                  _withDirectives(_createVNode("input", {
                                    type: "checkbox",
                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.selectedAddresses = $event)),
                                    id: address.id,
                                    value: address.id
                                  }, null, 8, ["id", "value"]), [
                                    [_vModelCheckbox, _ctx.selectedAddresses]
                                  ]),
                                  _hoisted_34
                                ]),
                                _createTextVNode(" " + _toDisplayString(address?.address_1 + ',' + address?.city + ',' + address?.country?.name), 1)
                              ]),
                              _createVNode("div", _hoisted_35, [
                                _createVNode("span", _hoisted_36, _toDisplayString(_ctx.$t('message.DEFAULT_SHIPPING_ADDRESS')), 1),
                                _createVNode("label", _hoisted_37, [
                                  _withDirectives(_createVNode("input", {
                                    type: "radio",
                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.selectedRadios = $event)),
                                    value: address.id,
                                    name: "defaultAddress",
                                    class: "toggle-input"
                                  }, null, 8, ["value"]), [
                                    [_vModelRadio, _ctx.selectedRadios]
                                  ]),
                                  _hoisted_38,
                                  _hoisted_39
                                ])
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("label", _hoisted_40, _toDisplayString(_ctx.$t('message.PERMISSIONS')), 1),
                _createVNode("div", _hoisted_41, [
                  _createVNode("div", null, [
                    _createVNode("label", _hoisted_42, [
                      _withDirectives(_createVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.allSelectAbility = $event)),
                        id: "all",
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.selectedAll($event, _ctx.customerAbilities)))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.allSelectAbility]
                      ]),
                      _hoisted_43
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('message.ALL')), 1)
                  ]),
                  _createVNode("ul", _hoisted_44, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.customerAbilities, (ability, index2) => {
                      return (_openBlock(), _createBlock("li", {
                        class: "list-group-item",
                        key: index2
                      }, [
                        _createVNode("label", _hoisted_45, [
                          _withDirectives(_createVNode("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.selectedAbilities = $event)),
                            id: ability.name,
                            value: ability.name
                          }, null, 8, ["id", "value"]), [
                            [_vModelCheckbox, _ctx.selectedAbilities]
                          ]),
                          _hoisted_46
                        ]),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t(`message.${ability?.name.toUpperCase()}`)), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_47, [
                _createVNode("button", _hoisted_48, _toDisplayString(_ctx.$t('message.CANCEL')), 1),
                _createVNode("button", {
                  type: "button",
                  class: "btn btn-custom",
                  onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.submitHandler && _ctx.submitHandler(...args)))
                }, [
                  _createVNode("span", _hoisted_49, _toDisplayString(_ctx.$t('message.SUBMIT')), 1)
                ])
              ])
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ])
    ])
  ], 64))
})